// extracted by mini-css-extract-plugin
module.exports = {"button":"state-card_button__QHajI","buttonImage":"state-card_buttonImage__EKGZq","stateSelected":"state-card_stateSelected__Z9oSD"};